/**
 * Whether a distribution-warehouse brand names Amazon. The backend normalizes
 * the brand (trim, case) before it decides a delivery is Amazon; every client
 * gate must agree with it, or a stored "Amazon" shows the plain reference
 * field while the server insists on the two ids.
 */
export function isAmazonDistributionWarehouseBrand(
  brand: string | null | undefined,
): boolean {
  return brand?.trim().toLowerCase() === "amazon";
}
